<template>
    <div>
        <step-bar @redirect="redirect" :index="index" :items="items"></step-bar>
        <el-form class="moteurForm" label-position="top" :ref="factoryEngine" :model="factoryEngine" :rules="rules">
            <div class="top">
                <el-row :gutter="24">
                    <el-col :xs="24" :sm="12">
                        <el-form-item :label="getText('motor_form_name')" prop="name" :show-message="showMessage('name')">
                            <el-input
                                v-model="factoryEngine.name"
                                required
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <el-form-item :label="getText('motor_form_description')">
                            <el-input
                                class="formDesc"
                                v-model="factoryEngine.comment"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
            <slot name="main"></slot>
            <navigation
                v-model="index"
                :loading="loading"
                :start="start"
                :end="end"
                :valid="valid"
                :disable="!checkMoteurIntegrity()"
                @cancel="cancel"
                @save="save"
                ref="nav"
            ></navigation>
        </el-form>
    </div>
</template>

<script>

import StepBar from './StepBar.vue';
import Navigation from './Navigation.vue';
import {mapGetters} from 'vuex';

export default {
    data () {
        return {
            index: 0,
            lang: this.getLangage,
            valid: false,
            items: [],
            nameMessage: false,
        };
    },
    props: {
        loading: {
            type: Boolean,
            required: true
        },
        factoryEngine: {
            type: Object,
            required: true
        },
        rules: {
            type: Object,
            required: true
        }
    },
    watch: {
        index: function(newValue, oldValue) {
            if (this.factoryEngine.application_type === 'motor') {
                if (oldValue === 1 && newValue === 2){
                    this.index = 4;
                }
                if (oldValue === 4 && newValue === 3){
                    this.index = 1;
                }
            }
            this.update();
        },
    },
    components: {
        StepBar,
        Navigation,
    },
    mounted(){
        this.update();
        this.items = this.$slots.main.map(s =>{
            return s.componentInstance.name;
        });
    },
    computed: {
        ...mapGetters([
            'getText',
            'getLangage'
        ]),
        start(){
            return 0;
        },
        end(){
            return this.$slots.main.length -1;
        },
    },
    methods:{
        showMessage(el) {
            if (this.factoryEngine[el].length)
                return true;
            return false;
        },
        checkMoteurIntegrity() {
            if (this.lang != this.getLangage) {
                this.lang = this.getLangage;
            }
            if (this.$refs[this.factoryEngine]) {
                this.$refs[this.factoryEngine].validate((valid) => {
                    if (valid) {
                        this.valid = true;
                    }
                    else {
                        this.valid = false;
                    }
                });
            }
            return this.valid;
        },
        redirect(value) {
            this.index = value;
        },
        update(){
            for(let s of this.$slots.main){
                s.componentInstance.hide();
            }
            this.$slots.main[this.index].componentInstance.show();
        },
        save(index) {
            this.$emit('save', index);
        },
        cancel(index) {
            this.$emit('cancel', index);
        }
    }
};

</script>

<style lang="less">

@import '../../../less/variables';

.top {
    width: 80%;
    display: flex;
    margin-bottom: 50px !important;
    flex-direction: row;
    margin: auto;
    justify-content: space-between;
    // .md-input-container {
    //     width: 40%;
    //     margin-bottom: auto;
    // }
}

// .next {
//     float: right;
// }

.moteurForm {
    .el-row {
        width: 100%;
        label {
            margin-top: 20px;
            padding: 0;
            height: 30px;
        }
        input {
            padding: 0;
            border-left: none;
            border-top: none;
            border-right: none;
            border-radius: 0;
            border-bottom-color: @color-1;
            &:focus {
                border-bottom-color: @color-1 !important;
                border-width: 2px;
            }
        }
        .formDesc {
            overflow-wrap: break-word;
        }
    }
}

.el-form-item {
    width: 90%;
    margin: auto;
}
.el-form-item.is-success .el-input__inner{
    border-bottom-color: @color-1;
}

.box {
    height: 70vh;
    width: 80vw;
    margin: 20px auto;
    background-color: pink;
}
</style>


// WEBPACK FOOTER //
// src/components/partials/wizzard/Stepper.vue